module.exports = __webpack_public_path__ + "img/allianz.fc7da02b.png";